/**
 * Tunable Ideas ranking weights — rarity-first, not field-completeness.
 * Common facts (born-as, studio, typical age) stay near zero so they cannot
 * float mainstream tracks. Keep every weight here — do not scatter numbers.
 */
export const IDEA_SCORE_WEIGHTS = {
  /** Legal / birth alias — ubiquitous on Persons; almost no ranking signal. */
  aliasBornAs: 2,
  /** Non-empty MB annotation (~few % of library). */
  annotation: 55,
  /** Recording place / studio — interesting on the card, weak for rank. */
  recordingPlace: 4,
  /** Multiple release years / reissue span. */
  reissues: 22,
  /** Release after artist death — rare story beat. */
  posthumous: 90,
  /** Age at recording in the boring band (21–50). Near-zero. */
  ageTypical: 1,
  /** Age ≤21 or ≥50 — genuine outlier. */
  ageOutlier: 60,
  /** Multi-artist credit — too common to rank on. */
  collaboration: 0,
  /** Linked label marked ended / defunct. */
  defunctLabel: 28,
  /** Forward “samples material” / “samples from artist” only. */
  samples: 58,
  /** Country or area — baseline noise. */
  country: 0,
  /** Life-span begin/end years — baseline noise. */
  years: 0,
  /** Any label credit — baseline noise. */
  label: 0,
} as const;

export type IdeaScoreWeightKey = keyof typeof IDEA_SCORE_WEIGHTS;

/** Max tracks kept per primary artist in the default Ideas list. */
export const IDEA_MAX_PER_ARTIST = 2;

/** Fact-type filter keys exposed on the Ideas page. */
export const IDEA_FACT_FILTERS = [
  "alias",
  "annotation",
  "place",
  "reissues",
  "posthumous",
  "age",
  "collaboration",
  "defunct_label",
  "samples",
  "country",
  "years",
] as const;

export type IdeaFactFilter = (typeof IDEA_FACT_FILTERS)[number];
